import { render, staticRenderFns } from "./EditBasketCategoryDialog.vue?vue&type=template&id=6584e0d0"
import script from "./EditBasketCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditBasketCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports